// extracted by mini-css-extract-plugin
export default {"tableSettingsToolbar":"styles_table-settings-toolbar__SrKr1"};